import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardActionArea, Box } from '@mui/material';
import { BarChart, Speed, Storage } from '@mui/icons-material';
import AdminLayout from '../../components/admin/AdminLayout';

const tools = [
  {
    title: 'Grafana',
    description: 'Dashboards for API, billing, infrastructure, and WebSocket metrics',
    icon: <BarChart sx={{ fontSize: 64 }} />,
    color: '#F46800',
    url: 'http://localhost:3001',
  },
  {
    title: 'Metrics',
    description: 'Raw Prometheus metrics from the backend service',
    icon: <Speed sx={{ fontSize: 64 }} />,
    color: '#1976d2',
    url: 'http://localhost:8080/metrics',
  },
  {
    title: 'Prometheus',
    description: 'Query engine, targets, and alerting rules',
    icon: <Storage sx={{ fontSize: 64 }} />,
    color: '#E6522C',
    url: 'http://localhost:9090',
  },
];

export default function MonitorPlatform() {
  return (
    <AdminLayout title="Monitor Platform">
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 1 }}>
          Platform Monitoring
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Observability tools for metrics, traces, and dashboards
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {tools.map((tool) => (
            <Grid item xs={12} sm={6} md={4} key={tool.title}>
              <Card elevation={3} sx={{ height: '100%' }}>
                <CardActionArea
                  href={tool.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ height: '100%', p: 2 }}
                >
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Box sx={{ color: tool.color, mb: 2 }}>
                      {tool.icon}
                    </Box>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {tool.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {tool.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </AdminLayout>
  );
}
